import { Injectable }       from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { UserVideo } from 'src/app/models/user-video';
import { Playlist } from 'src/app/models/playlist';
import { Report } from 'src/app/models/report';

import { BaseService } from './base.service';

// import 'rxjs/add/operator/toPromise';

@Injectable()
export class VideoService extends BaseService {
  
  constructor(
    // private auth: Auth,
    private http: HttpClient,
) {
    super();
  }

  /*
   * @param string   hash          (required)
   */
  async password(videohash: string, password: string): Promise<any> {

    let body = JSON.stringify({
      password: password,
    });

    let headers:any = new HttpHeaders().set('Content-Type', 'application/json');
    let url = "password?v=" + videohash;
    return this.http.post(this.getPlayerUrl(url), body, {headers: headers})
               .toPromise()
               .then((response: any) => {
                 
                 if(! response){
                   return this.handleError;
                 }
                 console.log(response);
                 return response;
               })
               .catch(this.handleError);
  }

}

